(function () {
  'use strict';

  var popupKey = 'hokema-localization-choice-v1';
  var languageKey = 'hokema-language-choice-v1';
  var shippingKey = 'hokema-shipping-destination-v1-b2c';
  var lifetime = 180 * 24 * 60 * 60 * 1000;

  function code(value) {
    return String(value || '').trim().toLowerCase();
  }

  function countryCode(value) {
    return String(value || '').trim().toUpperCase();
  }

  function regionCode(value) {
    var region = countryCode(value).replace(/^GB-/, '');
    return ['ENG', 'SCT', 'WLS', 'NIR', 'BFP'].indexOf(region) === -1 ? '' : region;
  }

  function preferredRegion(country, stored, address) {
    if (countryCode(country) !== 'GB') return '';
    var saved = countryCode(stored && stored.country) === 'GB' ? regionCode(stored.region) : '';
    if (saved) return saved;
    return countryCode(address && address.country) === 'GB' ? regionCode(address.region) : '';
  }

  function allowed(values, value, transform) {
    var normalized = transform(value);
    return (values || []).some(function (entry) { return transform(entry) === normalized; }) ? normalized : '';
  }

  function preferredLanguage(browserLanguages, currentLanguage, availableLanguages) {
    var current = allowed(availableLanguages, currentLanguage, code) || code(currentLanguage);
    var primary = Array.isArray(browserLanguages) ? browserLanguages.find(Boolean) : browserLanguages;
    if (!primary) return current;
    var desired = /^de(?:-|$)/i.test(String(primary)) ? 'de' : 'en';
    return allowed(availableLanguages, desired, code) || current;
  }

  function recommendationCountry(payload, availableCountries, fallback) {
    var detected = payload && payload.detected_values && payload.detected_values.country;
    var value = allowed(availableCountries, detected && detected.handle, countryCode);
    if (value) return value;
    var suggestions = payload && Array.isArray(payload.suggestions) ? payload.suggestions : [];
    suggestions = suggestions.slice().sort(function (a, b) {
      return Number(Boolean(b && b.is_preferred)) - Number(Boolean(a && a.is_preferred));
    });
    for (var index = 0; index < suggestions.length; index += 1) {
      var part = suggestions[index] && suggestions[index].parts && suggestions[index].parts.country;
      value = allowed(availableCountries, part && part.handle, countryCode);
      if (value) return value;
    }
    return allowed(availableCountries, fallback, countryCode) || countryCode(fallback);
  }

  function validStoredChoice(value, now) {
    return Boolean(value && typeof value === 'object' && Number(value.expires) > Number(now));
  }

  function returnTo(location) {
    if (!location) return '/';
    return String(location.pathname || '/') + String(location.search || '') + String(location.hash || '');
  }

  function isPopupPreview(search, theme, isB2b) {
    return !isB2b && Boolean(theme && theme.role === 'unpublished')
      && new URLSearchParams(search || '').get('hk_localization_preview') === '1';
  }

  function elementVisible(element) {
    if (!element || !element.isConnected
      || element.closest('details:not([open]), [hidden], [aria-hidden="true"], [inert]')
      || !element.getClientRects().length) return false;
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  var helpers = {
    regionCode: regionCode,
    preferredRegion: preferredRegion,
    preferredLanguage: preferredLanguage,
    recommendationCountry: recommendationCountry,
    validStoredChoice: validStoredChoice,
    returnTo: returnTo,
    isPopupPreview: isPopupPreview,
    elementVisible: elementVisible
  };

  if (typeof module !== 'undefined' && module.exports) module.exports = helpers;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var configElement = document.getElementById('hokema-localization-config');
  if (!configElement || window.HokemaLocalizationInitialized) return;
  window.HokemaLocalizationInitialized = true;

  var config;
  try { config = JSON.parse(configElement.textContent || '{}'); } catch (error) { return; }
  var popupPreview = isPopupPreview(window.location.search, window.Shopify && window.Shopify.theme, config.isB2b);

  var availableCountries = Array.isArray(config.availableCountries) ? config.availableCountries : [];
  var availableLanguages = Array.isArray(config.availableLanguages) ? config.availableLanguages : [];
  var currentCountry = allowed(availableCountries, config.currentCountry, countryCode) || countryCode(config.currentCountry);
  var currentLanguage = allowed(availableLanguages, config.currentLanguage, code) || code(config.currentLanguage);
  var browserLanguages = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];

  function readStorage(key) {
    try { return JSON.parse(window.localStorage.getItem(key)); } catch (error) { return null; }
  }

  function writeStorage(key, value) {
    try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (error) {}
  }

  function storedLanguage() {
    var value = readStorage(languageKey);
    return value && validStoredChoice(value, Date.now())
      ? allowed(availableLanguages, value.language, code)
      : '';
  }

  function rememberLanguage(language) {
    var normalized = allowed(availableLanguages, language, code);
    if (!normalized) return;
    writeStorage(languageKey, { language: normalized, expires: Date.now() + lifetime });
  }

  function rememberPopup(action, country, language) {
    if (popupPreview) return;
    writeStorage(popupKey, {
      action: action,
      country: country,
      language: language,
      expires: Date.now() + lifetime
    });
  }

  function shippingSelection(country, region) {
    var normalized = allowed(availableCountries, country, countryCode);
    if (!normalized) return null;
    var stored = readStorage(shippingKey);
    var selectedRegion = region === undefined ? preferredRegion(normalized, stored, null) : regionCode(region);
    return { country: normalized, region: normalized === 'GB' ? selectedRegion : '' };
  }

  function syncShipping(country, region) {
    var selection = shippingSelection(country, region);
    if (!selection) return;
    writeStorage(shippingKey, selection);
    document.dispatchEvent(new CustomEvent('hokema:shipping:destination', {
      detail: { key: shippingKey, selection: selection }
    }));
  }

  function updateReturnTo(form) {
    if (!form) return;
    var input = form.querySelector('[name="return_to"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'return_to';
      form.appendChild(input);
    }
    var destination = new URL(returnTo(window.location), window.location.origin);
    destination.searchParams.delete('hk_localization_preview');
    input.value = destination.pathname + destination.search + destination.hash;
  }

  function submitLanguage(language) {
    var form = document.getElementById(config.isB2b ? 'HokemaAutomaticLanguageForm' : 'HokemaLocalizationForm');
    var input = form && form.querySelector('[name="language_code"]');
    var desired = allowed(availableLanguages, language, code);
    if (!form || !input || !desired || desired === currentLanguage) return false;
    var attemptKey = 'hokema-language-attempt-v1:' + currentLanguage + ':' + desired;
    try {
      if (window.sessionStorage.getItem(attemptKey)) return false;
      window.sessionStorage.setItem(attemptKey, '1');
    } catch (error) {}
    input.value = desired;
    if (!config.isB2b) {
      var country = form.querySelector('[name="country_code"]');
      if (country) country.value = currentCountry;
    }
    updateReturnTo(form);
    HTMLFormElement.prototype.submit.call(form);
    return true;
  }

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    var languageOption = target && target.closest('.select-popout--lang [data-popout-option]');
    if (languageOption) {
      var language = allowed(availableLanguages, languageOption.getAttribute('data-value'), code);
      if (language) {
        rememberLanguage(language);
        if (!config.isB2b) rememberPopup('manual', currentCountry, language);
      }
      return;
    }
    if (config.isB2b) return;
    var countryOption = target && target.closest('.select-popout--country [data-popout-option]');
    if (!countryOption) return;
    var country = allowed(availableCountries, countryOption.getAttribute('data-value'), countryCode);
    if (!country) return;
    syncShipping(country);
    rememberPopup('manual', country, currentLanguage);
  }, true);

  if (window.Shopify && window.Shopify.designMode) return;

  var manualLanguage = popupPreview ? '' : storedLanguage();
  var desiredLanguage = manualLanguage || preferredLanguage(browserLanguages, currentLanguage, availableLanguages);

  if (config.isB2b) {
    submitLanguage(desiredLanguage);
    return;
  }

  if (manualLanguage && manualLanguage !== currentLanguage && submitLanguage(manualLanguage)) return;

  var rememberedPopup = readStorage(popupKey);
  if (!popupPreview && validStoredChoice(rememberedPopup, Date.now())) return;

  var dialog = document.getElementById('hokema-localization-dialog');
  var form = document.getElementById('HokemaLocalizationForm');
  var countryInput = form && form.querySelector('[data-hk-localization-country]');
  var languageInput = form && form.querySelector('[data-hk-localization-language]');
  var regionInput = form && form.querySelector('[data-hk-localization-region]');
  var regionHolder = form && form.querySelector('[data-hk-localization-region-holder]');
  var applyButton = form && form.querySelector('[data-hk-localization-apply]');
  var countryNotice = form && form.querySelector('[data-hk-localization-notice]');
  if (!dialog || !form || !countryInput || !languageInput || !regionInput || !regionHolder || !applyButton || !countryNotice || typeof dialog.showModal !== 'function') return;

  var popupRegion = preferredRegion('GB', readStorage(shippingKey), config.customerAddress);

  function updateRegionField() {
    var isUnitedKingdom = countryCode(countryInput.value) === 'GB';
    regionHolder.hidden = !isUnitedKingdom;
    regionInput.disabled = !isUnitedKingdom;
    regionInput.required = isUnitedKingdom;
    regionInput.value = isUnitedKingdom ? popupRegion : '';
  }

  function updateCountryUI() {
    updateRegionField();
    var isUnitedStates = countryCode(countryInput.value) === 'US';
    applyButton.textContent = isUnitedStates ? applyButton.dataset.usText : applyButton.dataset.defaultText;
    countryNotice.textContent = isUnitedStates ? countryNotice.dataset.usText : countryNotice.dataset.defaultText;
  }

  countryInput.addEventListener('change', updateCountryUI);
  regionInput.addEventListener('change', function () {
    popupRegion = regionCode(regionInput.value);
  });

  document.documentElement.dataset.hokemaLocalizationPending = 'true';
  var previousFocus;
  var previousOverflow;
  var openingFinished = false;

  function shopifyFormOpen() {
    var hosts = document.querySelectorAll('shopify-forms-embed');
    for (var index = 0; index < hosts.length; index += 1) {
      var root = hosts[index].shadowRoot;
      var overlay = root && root.querySelector('[data-layout="overlay"] [role="dialog"], [data-layout="overlay"][role="dialog"]');
      if (elementVisible(overlay)) return true;
    }
    return false;
  }

  function anotherInterfaceOpen() {
    if (shopifyFormOpen()) return true;
    if (document.body.classList.contains('js-drawer-open')
      || document.body.classList.contains('js-drawer-open-cart')
      || document.body.classList.contains('js-quick-view-visible')
      || document.body.classList.contains('js-quick-view-from-cart')) return true;
    if (document.querySelector('cart-items[data-cart-drawer].is-open, drawer-element.is-open, .pswp.pswp--open')) return true;
    var interfaces = document.querySelectorAll('dialog[open], [aria-modal="true"], [role="dialog"], .popup--visible');
    for (var index = 0; index < interfaces.length; index += 1) {
      if (interfaces[index] !== dialog && elementVisible(interfaces[index])) return true;
    }
    return false;
  }

  function setCooldown() {
    window.hokemaLocalizationCooldownUntil = Date.now() + 15000;
  }

  function clearDialogState() {
    delete document.documentElement.dataset.hokemaLocalizationActive;
    delete document.documentElement.dataset.hokemaLocalizationPending;
  }

  function closeDialog() {
    setCooldown();
    if (dialog.open) dialog.close();
    else clearDialogState();
  }

  function keepCurrent() {
    rememberPopup('keep', currentCountry, currentLanguage);
    syncShipping(currentCountry);
    closeDialog();
  }

  function dismissDialog() {
    rememberPopup('dismissed', currentCountry, currentLanguage);
    closeDialog();
  }

  dialog.querySelectorAll('[data-hk-localization-keep]').forEach(function (button) {
    button.addEventListener('click', keepCurrent);
  });

  dialog.querySelectorAll('[data-hk-localization-dismiss]').forEach(function (button) {
    button.addEventListener('click', dismissDialog);
  });

  dialog.addEventListener('cancel', function (event) {
    event.preventDefault();
    dismissDialog();
  });

  dialog.addEventListener('click', function (event) {
    if (event.target !== dialog) return;
    var bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right
      || event.clientY < bounds.top || event.clientY > bounds.bottom) dismissDialog();
  });

  dialog.addEventListener('close', function () {
    clearDialogState();
    if (previousOverflow !== undefined) document.documentElement.style.overflow = previousOverflow;
    previousOverflow = undefined;
    if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    var country = allowed(availableCountries, countryInput.value, countryCode);
    var language = allowed(availableLanguages, languageInput.value, code);
    if (!country || !language) return;
    if (country === 'US') {
      closeDialog();
      window.location.assign('https://hokema.us/');
      return;
    }
    var region = country === 'GB' ? regionCode(regionInput.value) : '';
    if (country === 'GB' && !region) {
      regionInput.focus({ preventScroll: true });
      regionInput.reportValidity();
      return;
    }
    rememberPopup('selected', country, language);
    rememberLanguage(language);
    syncShipping(country, region);
    closeDialog();
    if (country === currentCountry && language === currentLanguage) return;
    updateReturnTo(form);
    HTMLFormElement.prototype.submit.call(form);
  });

  window.addEventListener('pagehide', function () {
    if (dialog.open) dialog.close();
  });

  async function detectCountry() {
    var stored = readStorage(shippingKey);
    var storedShipping = shippingSelection(stored && stored.country);
    if (!popupPreview && storedShipping) return storedShipping.country;
    var fallback = currentCountry;
    var controller = typeof AbortController === 'undefined' ? null : new AbortController();
    var timeout = controller ? window.setTimeout(function () { controller.abort(); }, 5000) : null;
    try {
      var root = new URL(config.rootUrl || '/', window.location.origin);
      if (root.origin !== window.location.origin) return fallback;
      if (!root.pathname.endsWith('/')) root.pathname += '/';
      var url = new URL('browsing_context_suggestions.json', root);
      url.searchParams.set('country[enabled]', 'true');
      url.searchParams.set('language[enabled]', 'false');
      var response = await window.fetch(url.toString(), {
        method: 'GET',
        credentials: 'omit',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
        signal: controller ? controller.signal : undefined
      });
      if (!response.ok) return fallback;
      return recommendationCountry(await response.json(), availableCountries, fallback);
    } catch (error) {
      return fallback;
    } finally {
      if (timeout) window.clearTimeout(timeout);
    }
  }

  function openWhenReady() {
    var deadline = Date.now() + 45000;
    function attempt() {
      if (!dialog.isConnected || (!popupPreview && validStoredChoice(readStorage(popupKey), Date.now()))) {
        clearDialogState();
        return;
      }
      if (document.visibilityState === 'hidden' || anotherInterfaceOpen()) {
        if (Date.now() < deadline) {
          window.setTimeout(attempt, 500);
        } else {
          clearDialogState();
        }
        return;
      }
      previousFocus = document.activeElement;
      previousOverflow = document.documentElement.style.overflow;
      try {
        dialog.showModal();
        document.documentElement.dataset.hokemaLocalizationActive = 'true';
        delete document.documentElement.dataset.hokemaLocalizationPending;
        document.documentElement.style.overflow = 'hidden';
        countryInput.focus({ preventScroll: true });
      } catch (error) {
        previousOverflow = undefined;
        clearDialogState();
      }
    }
    window.setTimeout(attempt, 900);
  }

  detectCountry().then(function (country) {
    if (openingFinished) return;
    openingFinished = true;
    var primaryBrowserLanguage = browserLanguages.find(Boolean);
    if (countryCode(country) === 'DE' && /^de(?:-|$)/i.test(String(primaryBrowserLanguage || ''))) {
      clearDialogState();
      return;
    }
    countryInput.value = allowed(availableCountries, country, countryCode) || currentCountry;
    languageInput.value = desiredLanguage || currentLanguage;
    updateCountryUI();
    openWhenReady();
  });
})();
